import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './ApiError';

/**
 * Domyślne ustawienia zapytań. Sensowna wartość ustawiona TUTAJ znaczy, że nikt
 * nie musi jej powtarzać przy każdym hooku — a rozjazd domyślnych w kilkunastu
 * miejscach jest jednym z częstszych źródeł „u mnie działa".
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Graf zmienia się przez ludzi, nie przez zdarzenia zewnętrzne, więc
        // 30 s świeżości nie kłamie, a oszczędza lawinę zapytań przy chodzeniu
        // po drzewku tam i z powrotem.
        staleTime: 30_000,
        gcTime: 5 * 60_000,

        // Odświeżanie przy powrocie do karty ma sens: produkt jest wielouserowy
        // i po godzinie przerwy patrzy się na cudzą robotę sprzed godziny.
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,

        retry: (failureCount, error) => {
          // Ponawianie odpowiedzi, która jest ODMOWĄ, jest bez sensu i szkodliwe:
          // 401/403/404/409 to rozstrzygnięcia, nie usterki łącza. Przy 401
          // ponawianie dodatkowo opóźniałoby przekierowanie na logowanie.
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }

          return failureCount < 2;
        },
      },

      mutations: {
        // Zapisów nie ponawiamy automatycznie NIGDY. Przy operacjach, które nie
        // są idempotentne (dodanie relacji, odpalenie iteracji), ciche ponowienie
        // potrafi zrobić rzecz dwa razy. Ponowienie jest decyzją człowieka.
        retry: false,
      },
    },
  });
}
